<template>
  <div class="list-table-column-carousel-picture">
    <mk-image
      class="carousel-img"
      :src="url"
      :preview-src-list="previewSrcList"
      fit="cover"
    >
      <!-- <img
        slot="error"
        class="error-img"
        :src="imagePlaceholder"
      > -->
      <ds-iconfont
        slot="error"
        icon-class="icon-mk-tupianyangshi"
      >
      </ds-iconfont>
    </mk-image>
  </div>
</template>

<script>
export default {
  name: 'ListTableColumnCarouselPicture',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 图片预览设置
      previewSrcList: []
    }
  },
  computed: {
    url () {
      return this.scope.row.carouselPicture.length > 0 ? this.scope.row.carouselPicture[0].url : ''
    }
  },
  watch: {
    scope () {
      this.initPicturePreview()
    }
  },
  mounted () {
    this.initPicturePreview()
  },
  methods: {
    initPicturePreview () {
      this.previewSrcList = []
      if (this.scope.row.carouselPicture.length > 0) {
        this.previewSrcList.push(this.url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-table-column-carousel-picture {
  display: flex;
  align-content: center;

  .carousel-img {
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 2px;
    text-align: center;
    border: 1px solid #d9d9d9;
  }

  img {
    width: 26px;
    height: 26px;
    // border-radius: 8px;
  }

  .icon-mk-tupianyangshi {
    width: 18px;
    height: 18px;
    font-size: 18px;
    color: #e8e8e8;
  }
}
</style>
